export const PERCENTAGE_CHECK_BUCKETS = ['all', 'below', 'at100', 'above'] as const;
export type PercentageCheckBucket = (typeof PERCENTAGE_CHECK_BUCKETS)[number];

export const PERCENTAGE_CHECK_ROW_BUCKETS = ['zero', 'below', 'at100', 'above'] as const;
export type PercentageCheckRowBucket = (typeof PERCENTAGE_CHECK_ROW_BUCKETS)[number];

export const PERCENTAGE_CHECK_SORT_FIELDS = [
  'professional',
  'registrationNumber',
  'unit',
  'contractType',
  'maxPercentage',
  'minPercentage',
  'avgPercentage',
  'daysAbove',
  'daysBelow',
] as const;
export type PercentageCheckSortField = (typeof PERCENTAGE_CHECK_SORT_FIELDS)[number];

export const PERCENTAGE_CHECK_RANGE_KEYS = [
  'maxPercentage',
  'minPercentage',
  'daysBelow',
  'daysAbove',
] as const;
export type PercentageCheckRangeKey = (typeof PERCENTAGE_CHECK_RANGE_KEYS)[number];

export type PercentageCheckFilters = {
  startDate: string;
  endDate: string;
  bucket?: PercentageCheckBucket;
  professionalIds?: number[];
  professionalSearch?: string;
  contractTypeIds?: number[];
  contractStatusIds?: number[];
  unitIds?: number[];
  maxPercentageFrom?: number;
  maxPercentageTo?: number;
  minPercentageFrom?: number;
  minPercentageTo?: number;
  daysBelowFrom?: number;
  daysBelowTo?: number;
  daysAboveFrom?: number;
  daysAboveTo?: number;
  sortBy?: PercentageCheckSortField;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  perPage?: number;
};

export type PercentageCheckAllocation = {
  id: number;
  projectId: number;
  projectAxisCode: string | null;
  projectName: string;
  startDate: string;
  endDate: string | null;
  allocatedPercentage: number;
  billable: boolean;
};

export type PercentageCheckRow = {
  professionalId: number;
  professionalContractId: number;
  registrationNumber: number | null;
  professionalName: string;
  unitCode: string | null;
  contractType: string | null;
  contractStatus: string;
  minPercentage: number;
  maxPercentage: number;
  avgPercentage: number;
  daysZero: number;
  daysBelow: number;
  daysAt100: number;
  daysAbove: number;
  windowDays: number;
  bucket: PercentageCheckRowBucket;
  allocations: PercentageCheckAllocation[] | null;
  hiddenAllocationsCount: number;
};

export type PercentageCheckSummary = {
  totalProfessionals: number;
  totalBelow: number;
  totalZero: number;
  totalAt100: number;
  totalAbove: number;
  totalMixed: number;
};

export type PercentageCheckFilterOption = {
  id: number;
  name: string;
};

export type PercentageCheckUnitOption = {
  id: number;
  code: string;
};

export type PercentageCheckFilterOptions = {
  contractTypes: PercentageCheckFilterOption[];
  contractStatuses: PercentageCheckFilterOption[];
  units: PercentageCheckUnitOption[];
};

export type PercentageCheckResponse = {
  startDate: string;
  endDate: string;
  summary: PercentageCheckSummary;
  items: PercentageCheckRow[];
  pagination: { page: number; perPage: number; total: number };
  filterOptions: PercentageCheckFilterOptions;
};
